module.exports = __webpack_public_path__ + "img/about-3.122e5db1.webp";